import React from 'react';
import { MuiTitle, Column, Columns } from 'src/ui/mui-ui-kit';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { ArcElement, Chart, Tooltip } from 'chart.js';
import { ComplianceSummary, ComplianceTable } from 'src/compliance';
import { fetchLoggedInUser, getUser } from '../../user';
import {
  fetchBackgroundAssessmentLogTypes,
  fetchComplianceDashboardData,
  getComplianceDashboardData,
  getBackgroundAssessmentLog,
} from '../redux';
import { createDashboardSummaryData } from '../utils';
import { UiReportDownload } from '../../ui/ui-kit/UiReportDownload';
import { useEffectAfterMount } from '../../ui';

Chart.register(ArcElement, Tooltip);

const ComplianceDashboard = ({
  user,
  userFilters,
  dashboardData,
  fetchComplianceDashboardData,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [filteredUnack, setFilteredUnack] = React.useState([]);
  const [filteredUnres, setFilteredUnres] = React.useState([]);

  const refreshDashboardData = () => {
    setLoading(true);
    return fetchComplianceDashboardData({
      accountId: user.accountId,
      financialInstitutionId: user.financialInstitutionId,
      merchantIds: userFilters.accounts,
      start: userFilters.startDate,
      end: userFilters.endDate,
    }).then(() => {
      setLoading(false);
    });
  };

  // On an update from using the dropdown menu in a table row
  const onUpdate = async () => {
    setLoading(true);
    await refreshDashboardData();
    setLoading(false);
  };
  // React.useEffect(() => {
  //   (async () => {
  //     await fetchComplianceDashboardData({
  //       accountId: user.accountId,
  //       financialInstitutionId: user.financialInstitutionId,
  //       merchantIds: userFilters.accounts,
  //       start: userFilters.startDate,
  //       end: userFilters.endDate,
  //     })
  //     setLoading(false);
  //   })();
  // }, []);
  useEffectAfterMount(() => {
    refreshDashboardData();
  }, [userFilters]);

  React.useEffect(() => {
    refreshDashboardData();
  }, []);

  return (
    <>
      <ComplianceSummary
        data={dashboardData.dashboardData}
        tableData={createDashboardSummaryData(dashboardData.dashboardData)}
      />
      <br />
      <Columns>
        <Column>
          <MuiTitle isSize="4" hasTextColor="info" tag="h2">
            Background Assessments Detail
          </MuiTitle>
        </Column>

        <Column style={{ textAlign: 'right' }}>
          <UiReportDownload
            data={[...filteredUnack, ...filteredUnres]}
            filename="Compliance"
          />
        </Column>
      </Columns>
      <MuiTitle isSize="6" hasTextColor="info" tag="h5">
        Unacknowledged Flaggings
      </MuiTitle>
      <ComplianceTable
        loading={loading}
        data={dashboardData.dashboardData?.unresolvedUnacknowledged || []}
        user={user}
        onUpdate={onUpdate}
        dataCallback={setFilteredUnack}
      />
      <br />
      <MuiTitle isSize="6" hasTextColor="info" tag="h5">
        Unresolved Flaggings
      </MuiTitle>
      <ComplianceTable
        loading={loading}
        data={dashboardData.dashboardData?.unresolvedAcknowledged || []}
        user={user}
        onUpdate={onUpdate}
        dataCallback={setFilteredUnres}
      />
    </>
  );
};

const mapStateToProps = state => ({
  user: getUser(state),
  dashboardData: getComplianceDashboardData(state),
  backgroundAssessmentLog: getBackgroundAssessmentLog(state),
});

const connectedComplianceDashboard = connect(mapStateToProps, {
  fetchLoggedInUser,
  fetchComplianceDashboardData,
  fetchBackgroundAssessmentLogTypes,
})(ComplianceDashboard);

ComplianceDashboard.propTypes = {
  userFilters: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  dashboardData: propTypes.object.isRequired,
  fetchComplianceDashboardData: propTypes.func.isRequired,
};

export { connectedComplianceDashboard as ComplianceDashboard };
